<!--EDITAR PERFIL-->
<!--<msc-header [company]="company" [access]="access"></msc-header>-->
<msc-header></msc-header>
<!--<msc-sidebar [me]="me" [company]="company" [access]="access" [sidebar]="sidebar"></msc-sidebar>-->

<section>
    <div class="py-6 mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-5">
        <div class="container-account__back lg:col-span-2" *ngIf="!myAccount">
            <a class="link link-back link-back--transparent" [routerLink]="['/organize', company.slug, 'users']">
                <span>{{ 'user.manage.title' | translate }}</span>

                <i class="icon icon-arrow-ios-up"></i>
            </a>
        </div>

        <header class="container-account__header box flex justify-start align-center lg:col-span-2" *ngIf="!myAccount">
            <div class="container-account__avatar">
                <msc-common-avatar [label]="user.name"
                    [pictureURL]="user.picture ? (user.picture + '?size=256') : null"></msc-common-avatar>
            </div>

            <h2 class="container-account__name">
                {{ user.name }}
            </h2>
        </header>


        <aside class="container-account__aside account-sidebar">
            <nav class="account-nav p-4">
                <ul class="account-nav__list">
                    <li class="account-nav__item" [routerLink]="['profile']" [routerLinkActive]="'active'">
                        <span class="account-nav__bar"></span>
                        <i class="icon icon-person account-nav__icon"></i>
                        <span class="account-nav__label">{{ (myAccount ? 'words.profile-edit' : 'words.profile') |
                            translate }}</span>
                    </li>

                    <li class="account-nav__item" [routerLink]="['settings']" [routerLinkActive]="'active'"
                        *ngIf="myAccount">
                        <span class="account-nav__bar"></span>
                        <i class="icon icon-settings account-nav__icon"></i>
                        <span class="account-nav__label">{{ 'words.my-settings' | translate }}</span>
                    </li>

                    <li class="account-nav__item" [routerLink]="['subscription']" [routerLinkActive]="'active'"
                        *ngIf="myAccount">
                        <span class="account-nav__bar"></span>
                        <i class="icon icon-credit-card account-nav__icon"></i>
                        <span class="account-nav__label">{{ 'words.my-subscription' | translate }}</span>
                    </li>

                    <li *ngIf="user" class="account-nav__item account-nav__item--toggle" (click)="displayed('access')"
                        [ngClass]="{'displayed': displays.access || isActivatedRoute('access'), 'active': isActivatedRoute('access')}">
                        <span class="account-nav__bar"></span>
                        <i class="icon icon-lock account-nav__icon"></i>
                        <span class="account-nav__label">{{ 'words.access' | translate }}</span>
                        <i class="icon icon-arrow-ios-down account-nav__chevron"></i>
                    </li>

                    <li class="account-nav__sub" *ngIf="user">
                        <ul>
                            <li class="account-nav__sub-item" [routerLink]="['access', 'learn']"
                                [routerLinkActive]="'active'">
                                <span class="account-nav__sub-label">
                                    <i class="icon icon-student"></i>
                                    {{ 'words.learn' | translate }}
                                </span>

                                <i class="icon account-nav__sub-status"
                                    [ngClass]="{'icon-checkmark-1': user.companyRoles.companyLearner, 'icon-close': !user.companyRoles.companyLearner}"></i>
                            </li>

                            <li class="account-nav__sub-item" [routerLink]="['access', 'create']"
                                [routerLinkActive]="'active'">
                                <span class="account-nav__sub-label">
                                    <i class="icon icon-color-palette"></i>
                                    {{ 'words.create' | translate }}
                                </span>

                                <i class="icon account-nav__sub-status"
                                    [ngClass]="{'icon-checkmark-1': user.companyRoles.companyAuthor, 'icon-close': !user.companyRoles.companyAuthor}"></i>
                            </li>

                            <li class="account-nav__sub-item" [routerLink]="['access', 'manage']"
                                [routerLinkActive]="'active'">
                                <span class="account-nav__sub-label">
                                    <i class="icon icon-mentor"></i>
                                    {{ 'words.coach' | translate }}
                                </span>

                                <i class="icon account-nav__sub-status"
                                    [ngClass]="{'icon-checkmark-1': user.companyRoles.companyManager, 'icon-close': !user.companyRoles.companyManager}"></i>
                            </li>

                            <li class="account-nav__sub-item" [routerLink]="['access', 'organize']"
                                [routerLinkActive]="'active'">
                                <span class="account-nav__sub-label">
                                    <i class="icon icon-calendar"></i>
                                    {{ 'words.organise' | translate }}
                                </span>

                                <i class="icon account-nav__sub-status"
                                    [ngClass]="{'icon-checkmark-1': user.companyRoles.companyAdministrator, 'icon-close': !user.companyRoles.companyAdministrator}"></i>
                            </li>

                            <ng-container *ngIf="user.id !== me.id">
                                <li class="account-nav__sub-item" [routerLink]="['access', 'settings']"
                                    [routerLinkActive]="'active'">
                                    <span class="account-nav__sub-label">
                                        <i class="icon icon-settings-2"></i>
                                        {{ 'words.access-period' | translate }}
                                    </span>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ul>
            </nav>

            <div class="account-help hidden">
                <div class="account-help__icon">
                    <i class="icon icon-question-mark-circle"></i>
                </div>

                <p class="account-help__title">{{ 'account.aside.help-title' | translate }}</p>
                <p class="account-help__subtitle">{{ 'account.aside.help-subtitle' | translate }}</p>

                <button type="button" class="account-help__link">
                    {{ 'account.aside.help-contact' | translate }}
                    <i class="icon icon-arrow-ios-right"></i>
                </button>
            </div>
        </aside>

        <div class="container-account__body no-gutter">
            <router-outlet></router-outlet>
        </div>

    </div>
</section>